import { faPlusCircle, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState, useEffect, useReducer } from "react";
import { useLocation } from "react-router-dom";
import { Column, Row } from "../../common/columns";
import DashboardItem from "../../common/dashboard/DashboardItem";
import { useQuery } from "../../common/hooks/useQuery";
import { cutShort, cleanJoin } from "../../utils/stringUtil";
import RequestSubmission from "../requests/submission/RequestSubmission";
import Tabs from "../../common/tabs/Tabs";
import Tab from "../../common/tabs/Tab";
import { ThemeContext } from "../../common/theme/ThemeContext";
import { GET } from "../../utils/fetchUtil";
import { set } from "date-fns";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import Select from "../../common/select/Select";
import { useDebounce } from "../../common/hooks/useDebounce";

function SubmitRequestPage({ user }) {
  const categories = user.applicationConfiguration.categories;
  const filterSettingsArray = Object.values(user.applicationConfiguration.filterSettings);
  const filterSettings = user.applicationConfiguration.filterSettings;

  const location = useLocation();
  const query = useQuery();
  const [categoryQuery, setCategoryQuery] = useState("");
  const debouncedQuery = useDebounce(categoryQuery, 250);

  const [queryHelper, setQueryHelper] = useState("");

  const theme = useContext(ThemeContext);
  const [activeTab, setActiveTab] = useState(categories[0].value);

  const [isVisible, setIsVisible] = useState(false);
  const [showButton, setShowButton] = useState(false);
  //const [message, setMessage] = useState("");

  const [tipLokacije, setTipLokacije] = useState("");
  const [lokacija, setLokacija] = useState("");
  const [institucija, setInstitucija] = useState("");

  const [templates, setTemplates] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    if (
      (tipLokacije === "3" && lokacija !== "" && institucija !== "") ||
      (tipLokacije !== "3" && lokacija !== "") //poseban uvjet kada je drzava u filteru, onda se mora i institucija unijeti
    ) {
      GET(
        `/requests?location=${lokacija}&institution=${institucija}&category=${activeTab}`,
        (response) => {
          if (response.submitRequestPage.menu.length > 0) {
            setTemplates([response.submitRequestPage.menu[0].items]);
            if (response.submitRequestPage.menu[0].items.length >= 18) setShowButton(true);
          } else setTemplates([]);
        }
      );
    }
  }, [lokacija, institucija]);

  useEffect(() => {
    if (pageNumber !== 0) setPageNumber(0);
    GET(
      `/requests?location=${lokacija}&institution=${institucija}&category=${activeTab}${
        debouncedQuery.length > 0 ? `&search=${debouncedQuery}` : ""
      }`,
      (response) => {
        if (response.submitRequestPage.menu.length > 0) {
          setTemplates([response.submitRequestPage.menu[0].items]);
          setQueryHelper(debouncedQuery);
          setShowButton(true);
        } else setTemplates([]);
      }
    );
  }, [activeTab, debouncedQuery]);

  useEffect(() => {
    if (pageNumber !== 0)
      GET(
        `/requests?location=${lokacija}&institution=${institucija}&category=${activeTab}&pageNumber=${
          pageNumber + 1
        }${debouncedQuery.length > 0 ? `&search=${debouncedQuery}` : ""}`,
        (response) => {
          if (response.submitRequestPage.menu.length > 0) {
            setTemplates([...templates, response.submitRequestPage.menu[0].items]);
            //setQueryHelper("");
            const theElement = document.getElementById("contentId");

            const scrollToBottom = (node) => {
              node.scrollTop = node.scrollHeight;
            };

            scrollToBottom(theElement);
          } else {
            setShowButton(false);
          }
        }
      );
  }, [pageNumber]);

  const Filter = () => {
    return (
      <>
        {!isVisible && (
          <div className="mt-5 mx-5">
            <FontAwesomeIcon
              icon={faFilter}
              size={"2x"}
              className={"is-clickable "}
              // color={"green"}
              color="#80a9e1"
              onClick={() => {
                setIsVisible(!isVisible);
              }}
            />
          </div>
        )}
        {isVisible && (
          <Column className=" is-2 has-border-right-grey-1">
            <div className={"px-4 mt-1"}>
              <Row className="is-flex is-justify-content-flex-end">
                <u className="is-clickable" onClick={() => setIsVisible(false)}>
                  Sakrij filter polja
                </u>
              </Row>
              <Row className={"is-flex is-flex-direction-column  "}>
                <p className="pt-3 pb-1 mb-0">Tip lokacije: </p>
                <Select
                  value={tipLokacije}
                  label="Odaberite..."
                  options={filterSettings.locationTypes}
                  onChange={setTipLokacije}
                  setInstitucija={setInstitucija}
                  setLokacija={setLokacija}
                />
              </Row>

              <Row className={"is-flex is-flex-direction-column  "}>
                <p className="pt-3 pb-1 mb-0">Lokacija: </p>
                <Select
                  disabled={tipLokacije ? false : true}
                  value={lokacija}
                  required={true}
                  label="Odaberite..."
                  options={filterSettings.locations.filter(
                    (location) => location.relatedId === tipLokacije
                  )}
                  onChange={setLokacija}
                />
              </Row>

              <Row className={"is-flex is-flex-direction-column  "}>
                <p className="pt-3 pb-1 mb-0">Institucija: </p>
                <Select
                  disabled={tipLokacije ? false : true}
                  value={institucija}
                  label="Odaberite..."
                  required={tipLokacije === "3"}
                  options={filterSettings.institutions.filter(
                    (institution) => institution.relatedId === lokacija
                  )}
                  onChange={setInstitucija}
                />
              </Row>

              <Row className={"is-flex is-flex-direction-column  "}>
                <p className="pt-3 pb-1 mb-0">Kategorija: </p>
                <Select
                  disabled={tipLokacije ? false : true}
                  value={activeTab}
                  isCategory={true}
                  required={false}
                  label="Odaberite..."
                  onChange={setActiveTab}
                  options={filterSettings.categories}
                />
              </Row>

              <Row className=" mt-2 is-justify-content-flex-end">
                <button
                  className="button mr-0 is-flex-grow-0"
                  onClick={() => {
                    setTipLokacije("");
                    setLokacija("");
                    setInstitucija("");

                    GET(`/requests?category=${activeTab}`, (response) => {
                      if (response.submitRequestPage.menu.length > 0) {
                        setTemplates([response.submitRequestPage.menu[0].items]);
                        setQueryHelper(debouncedQuery);
                      } else setTemplates([]);
                    });
                  }}
                >
                  Odustani
                </button>
              </Row>
              {tipLokacije !== "" && (
                <Row className="is-flex-direction-column mt-2">
                  {lokacija === "" && (
                    <p className="has-text-danger mb-0">* Molimo odaberite lokaciju...</p>
                  )}
                  {tipLokacije === "3" && institucija === "" && (
                    <p className="has-text-danger">* Molimo odaberite instituciju...</p>
                  )}
                </Row>
              )}
            </div>
          </Column>
        )}
      </>
    );
  };

  const extraColumns = (number) => {
    const array = [];
    for (let i = 0; i < number; i++) {
      array.push(<Column className="is-2" />);
    }

    return array;
  };

  const mapper = (array, oldUser) => {
    return (
      <>
        {array.length > 0 &&
          array.map((item, itemIndex) => {
            return (
              <Column key={`item${itemIndex}`} className="is-2 p-2">
                <DashboardItem
                  title={item.label}
                  hasBorder={true}
                  institutionName={
                    item.institutionName && cutShort(item.institutionName, 40, "...")
                  }
                  locationName={item.locationName}
                  label={cutShort(item.label, 70, "...")}
                  labelAlignment="left"
                  labelSize="6"
                  link={`${location.pathname}`}
                  search={`?id=${item.id}&title=${item.label}`}
                  state={item.institutionId}
                  minHeight={140}
                  className={""}
                  contentPadding="p-3"
                >
                  <FontAwesomeIcon
                    className={cleanJoin(
                      `is-align-self-center  is-size-3`,
                      filterSettingsArray.length === 0 && `has-text-${theme.iconColor}`
                    )}
                    icon={faPlusCircle}
                    style={filterSettingsArray.length !== 0 && { color: item.color }}
                  />
                </DashboardItem>
              </Column>
            );
          })}
        {!oldUser && queryHelper.length === 0 && (
          <Column className={`is-${(6 - array.length) * 2} p-0`} />
        )}
        {/* {queryHelper.length === 0 &&
          array.length > 0 &&
          extraColumns(6 - array.length).map((col) => col)} */}
      </>
    );
  };

  const renderTemplates = (value) => {
    return (
      <>
        {activeTab === value && (
          <>
            {templates.map((page) => {
              if (filterSettingsArray.length === 0) return <>{mapper(page, true)}</>;
              return (
                <>
                  {mapper(page.filter((item) => item.color === "green"))}
                  {mapper(page.filter((item) => item.color === "purple"))}
                  {mapper(page.filter((item) => item.color === "blue"))}
                </>
              );
            })}
          </>
        )}
      </>
    );
  };

  return location.search ? (
    <RequestSubmission id={query.get("id")} uid={query.get("uid")} title={query.get("title")} />
  ) : (
    <div className="mx-2 is-flex-grow-1">
      <Tabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        //isScrollable={false}
        prefix={"tab"}
        scrollToSection={false}
        setCategoryQuery={setCategoryQuery}
        categoryQuery={categoryQuery}
        isFilter={filterSettingsArray.length > 0}
        filter={Filter}
        scrollableContentHeight={713}
      >
        {categories.map((tab) => (
          <Tab
            key={"tab" + tab.value}
            categoryId={tab.value}
            label={tab.label}
            render={() => {
              return (
                <>
                  <div className="subtitle  has-text-weight-bold mb-4">{tab.label}</div>
                  {/* <Content height={615}> */}
                  <Row className="is-multiline">
                    {templates.length > 0 && renderTemplates(tab.value)}
                    {filterSettingsArray.length > 0 && (
                      <Column className="is-full is-flex is-justify-content-center p-0">
                        {(activeTab !== "0" || debouncedQuery.length > 0) && (
                          <div className="has-text-centered  ">
                            {templates.length > 0 ? (
                              <>
                                {showButton ? (
                                  <button
                                    style={{ height: "2rem" }}
                                    className="is-clickable is-size-6 button"
                                    onClick={() => setPageNumber(pageNumber + 1)}
                                  >
                                    Učitaj još...
                                  </button>
                                ) : (
                                  <p>Nema više zahtjeva.</p>
                                )}
                              </>
                            ) : (
                              <p>Nema zahtjeva.</p>
                            )}
                          </div>
                        )}
                      </Column>
                    )}
                  </Row>
                  {/* </Content> */}
                </>
              );
            }}
          />
        ))}
      </Tabs>
    </div>
  );
}

export default SubmitRequestPage;
